import axios from 'axios'
import store from '@/store'
import { Message } from 'element-ui'
import router from '@/router'

// 创建axios实例
const service = axios.create({
  baseURL: 'prod-api/api', // api的base_urlhttp://112.26.89.154:18081/
//  baseURL: 'http://localhost:8080/api', // api的base_urlhttp://112.26.89.154:18081/
  timeout: 15000 // 请求超时时间
})
// http://112.26.89.154:18081/prod-api/api
// request拦截器
// || 'http://112.26.89.154:18081/prod-api/api'
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    if (store.getters['user/token']) {
      // sa-token：直接传token值，不需要Bearer前缀
      config.headers['satoken'] = store.getters['user/token']
    }
    
    // 设置Content-Type
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json'
    }
    
    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

// response拦截器
service.interceptors.response.use(
  response => {
    // blob 响应（文件下载）直接放行，不解析业务 code
    if (response.config && response.config.responseType === 'blob') {
      return response
    }
    // 对响应数据做点什么
    const res = response.data
    
    // 检查业务状态码 res.code
    if (res.code === 200) {
      // 业务状态码为200，请求成功
      return res
    } else {
      // 业务状态码不为200，统一处理业务错误
      const errorMsg = res.msg || '请求失败'
      console.error('API业务错误:', errorMsg, '状态码:', res.code)
      
      // 根据业务状态码处理
      switch (res.code) {
        case 400:
          // 参数错误，如果有具体字段错误，交给页面处理
          if (!res.errors) {
            Message.error(errorMsg)
          }
          break
        case 401:
          Message.error('未授权，请先登录')
          store.dispatch('user/logout').catch(() => {})
          setTimeout(() => {
            router.push('/login')
          }, 1500)
          break
        case 403:
          Message.error('没有权限访问')
          break
        case 409:
          Message.error(errorMsg)
          break
        case 500:
          Message.error(errorMsg)
          break
        default:
          Message.error(errorMsg)
      }
      
      // 构造错误对象供页面特殊处理
      const error = new Error(errorMsg)
      error.response = {
        status: res.code,
        data: res
      }
      return Promise.reject(error)
    }
  },
  error => {
    // 对响应错误做点什么（HTTP错误）
    console.error('Response error:', error)
    
    let message = '网络错误'
    
    if (error.response) {
      const status = error.response.status
      
      switch (status) {
        case 401:
          message = '未授权，请重新登录'
          store.dispatch('user/logout').catch(() => {})
          setTimeout(() => {
            router.push('/login')
          }, 1500)
          break
        case 403:
          message = '拒绝访问'
          break
        case 404:
          message = '请求地址不存在'
          break
        case 408:
          message = '请求超时'
          break
        case 500:
          message = '服务器内部错误'
          break
        case 502:
          message = '网关错误'
          break
        case 503:
          message = '服务不可用'
          break
        case 504:
          message = '网关超时'
          break
        default:
          message = `连接错误(${status})`
      }
    } else if (error.code === 'ECONNABORTED') {
      message = '请求超时'
    } else if (error.message) {
      message = error.message
    }
    
    // 统一显示错误提示
    Message.error(message)
    console.error('请求错误:', message)
    
    // 设置错误信息
    error.message = message
    
    // 抛出错误
    return Promise.reject(error)
  }
)

export default service
